import styled from 'styled-components';
export const WebSearchCardContainer = styled.div `
  background-color: ${({ theme }) => theme.colors.white_1};
  padding: ${({ theme }) => theme.spacing.md}px;
  border: 1px solid ${({ theme }) => theme.colors.grey_2};
  border-radius: ${({ theme }) => theme.border_radius.sm};
`;
export const WebSearchTitle = styled.div `
  margin-bottom: ${({ theme }) => theme.spacing.sm}px;
`;
export const WebSearchSummarySection = styled.div `
  margin-top: ${({ theme }) => theme.spacing.sm}px;
`;
export const WebSearchSummaryLabel = styled.div `
  margin-bottom: ${({ theme }) => theme.spacing.sm}px;
`;
export const WebSearchAnswerContent = styled.div `
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.6;
`;
export const WebSearchSourcesSection = styled.div `
  margin-top: ${({ theme }) => theme.spacing.md}px;
`;
export const WebSearchSourcesLabel = styled.div `
  margin-bottom: 0;
`;
export const WebSearchSourceLink = styled.div `
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.sm}px;
  padding: ${({ theme }) => `${theme.spacing.sm}px ${theme.spacing.sm}px`};
  background-color: ${({ theme, $hovered }) => $hovered ? theme.colors.beige_1 : theme.colors.white_1};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  text-decoration: none;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.grey_3};
  transition: background-color 0.2s;
`;
export const WebSearchSourceContent = styled.div `
  flex: 1;
  min-width: 0;
`;
export const WebSearchSourceTitle = styled.div `
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
`;
export const WebSearchSourceUrl = styled.div `
  font-size: ${({ theme }) => theme.fonts.body4};
  overflow-wrap: anywhere;
`;
export const WebSearchSourceDate = styled.div `
  font-size: ${({ theme }) => theme.fonts.body4};
`;
